/* __next_internal_client_entry_do_not_use__ SDUIProductTileImpressionProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { logWarning } from "@faire/web--source/common/logging";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import React from "react";
import { TrackedLinkContext } from "@faire/retailer/components/TrackedLink";
import { ProductTileClickImpressionProvider } from "@faire/retailer/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer/hooks/ProductTileImpression/ProductTileViewImpressionProvider";
import { CATEGORY_PRODUCT_TRACK_CLICK_CONTAINER_NAME } from "@faire/retailer/services/consts";
export var SDUIProductTileImpressionProvider = function(param) {
    var children = param.children, loggingData = param.loggingData;
    var productTileContainer = getProductTileContainer(loggingData);
    var context = getContext(productTileContainer, loggingData);
    var containerName = getProductTileClickImpressionContainerName(loggingData);
    var requestId = loggingData.request_id;
    var screenContext = getProductTileScreenContext(loggingData);
    var containerContext = getProductTileScreenContainerContext(loggingData);
    var contextToken = getContextToken(loggingData);
    return /*#__PURE__*/ _jsx(TrackedLinkContext.Provider, {
        value: {
            type: IClickInfo.Type.PRODUCT,
            requestId: requestId,
            containerName: containerName !== null && containerName !== void 0 ? containerName : ""
        },
        children: /*#__PURE__*/ _jsx(ProductTileViewImpressionProvider, {
            context: context,
            requestId: requestId,
            screenContext: screenContext,
            containerContext: containerContext,
            contextToken: contextToken,
            children: /*#__PURE__*/ _jsx(ProductTileClickImpressionProvider, {
                context: context,
                productTileContainer: productTileContainer,
                requestId: requestId,
                containerName: containerName,
                screenContext: screenContext,
                containerContext: containerContext,
                contextToken: contextToken,
                children: children
            })
        })
    });
};
var getContextToken = function(loggingData) {
    var _loggingData_component_instance_identifier, _ref;
    return (_ref = (_loggingData_component_instance_identifier = loggingData.component_instance_identifier) !== null && _loggingData_component_instance_identifier !== void 0 ? _loggingData_component_instance_identifier : loggingData.view_instance_identifier) !== null && _ref !== void 0 ? _ref : "";
};
var getContext = function(productTileContainer, loggingData) {
    if (loggingData.view_display_page === DisplayPageType.CATEGORY_PAGE && loggingData.section_type === "FilterablePaginatedSection" && loggingData.component_type === ILayoutElement.Type.PRODUCT_TILE_GRID) {
        var _loggingData_component_instance_identifier;
        return "".concat(productTileContainer, "|").concat((_loggingData_component_instance_identifier = loggingData.component_instance_identifier) !== null && _loggingData_component_instance_identifier !== void 0 ? _loggingData_component_instance_identifier : loggingData.view_instance_identifier);
    }
    if (!loggingData.component_name) {
        return "".concat(productTileContainer, "|unknown");
    }
    if (!loggingData.component_instance_identifier && !loggingData.view_instance_identifier) {
        return "".concat(productTileContainer, "|").concat(loggingData.component_name);
    }
    var _loggingData_component_instance_identifier1;
    return "".concat(productTileContainer, "|").concat(loggingData.component_name, "|").concat((_loggingData_component_instance_identifier1 = loggingData.component_instance_identifier) !== null && _loggingData_component_instance_identifier1 !== void 0 ? _loggingData_component_instance_identifier1 : loggingData.view_instance_identifier);
};
var getProductTileScreenContext = function(loggingData) {
    switch(loggingData.view_display_page){
        case DisplayPageType.CATEGORY_PAGE:
            return ProductTileScreen.CATEGORY_PRODUCT_RESULTS;
        case DisplayPageType.HOMEPAGE:
            return ProductTileScreen.HOME;
        case DisplayPageType.SEARCH_PAGE:
            return ProductTileScreen.SEARCH_PRODUCT_RESULTS;
        case DisplayPageType.DIGEST_PAGE:
            return ProductTileScreen.DIGEST_PAGE_SCREEN;
        case DisplayPageType.BRAND_DETAILS_PAGE:
            return ProductTileScreen.BRAND_PAGE;
        case DisplayPageType.CART_PAGE:
            return ProductTileScreen.CART;
        case DisplayPageType.PRODUCT_PAGE:
            return ProductTileScreen.PRODUCT;
        case DisplayPageType.SIMILAR_PRODUCTS_PAGE:
            return ProductTileScreen.SIMILAR_PRODUCTS;
        case DisplayPageType.BROWSE_LANDING_PAGE:
        default:
            return ProductTileScreen.PRODUCT_TILE_SCREEN_UNKNOWN;
    }
};
var getProductTileScreenContainerContext = function(loggingData) {
    return loggingData.component_name;
};
var getProductTileContainer = function(loggingData) {
    switch(loggingData.view_display_page){
        case DisplayPageType.CATEGORY_PAGE:
            if (loggingData.section_type === "FilterablePaginatedSection" && loggingData.component_type === ILayoutElement.Type.PRODUCT_TILE_GRID) {
                return ProductTileContainer.CATEGORY_PRODUCT_RESULTS_GRID;
            }
            return ProductTileContainer.CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL;
        case DisplayPageType.HOMEPAGE:
            return ProductTileContainer.HOMEPAGE_LAYOUT_ELEMENT_CAROUSEL;
        case DisplayPageType.DIGEST_PAGE:
            return ProductTileContainer.DIGEST_PAGE_LAYOUT_ELEMENT;
        case DisplayPageType.BRAND_DETAILS_PAGE:
            return ProductTileContainer.BRAND_PAGE_LAYOUT_ELEMENT;
        default:
            logWarning(new Error("SDUI ProductTileContainer is UNKNOWN for ".concat(loggingData === null || loggingData === void 0 ? void 0 : loggingData.view_display_page)), {
                data: loggingData
            });
            return ProductTileContainer.PRODUCT_TILE_CONTAINER_UNKNOWN;
    }
};
/**
 * This is needed to match legacy /click-track API container names
 */ var getProductTileClickImpressionContainerName = function(loggingData) {
    if (loggingData.view_display_page === DisplayPageType.CATEGORY_PAGE && loggingData.section_type === "FilterablePaginatedSection" && loggingData.component_type === ILayoutElement.Type.PRODUCT_TILE_GRID && loggingData.component_name === "CATEGORY_PRODUCT_RESULTS_PRODUCTS") {
        return "".concat(CATEGORY_PRODUCT_TRACK_CLICK_CONTAINER_NAME, "_old");
    }
    return loggingData.component_name;
};
